import { loginStart, loginError, loginSuccess } from './login';
import { getStore } from '../../../app/store';
import * as actionTypes from '../../constants/actions';
import { deleteCookie } from '../../utils/cookie';
import { setCurrentUser } from '../../utils/currentUser';
import {
  analyticsChangeUser,
  analyticsChangeClassRoom,
} from '../../utils/analytics';
import fetchUserBySessionToken from '../../api/users/fetchUserBySessionToken';

/**
 * fetchedUser is used in core/actions/startup/index.js
 * when grabbing startup data. Currently it's unclear
 * why we fetch the user again.
 */
export const fetchedUser = (user) => ({
  type: actionTypes.USER_FETCH_CURRENT,
  user,
});

export const logout = () => (dispatch, getState) =>
  new Promise((resolve) => {
    if (!getState().user.isLogged) {
      const err = 'User not logged in'; // new Error('User not logged in');
      resolve(err);
      // logoutError(err, dispatch);
      return;
    }

    dispatch({
      type: actionTypes.USER_LOGOUT,
      status: 'started',
    });

    deleteCookie('aula-logged', '', '.aula.education');
    dispatch({
      type: actionTypes.USER_LOGOUT,
      status: 'success',
    });
    analyticsChangeUser(getState);
    analyticsChangeClassRoom(getState);
  });

// Used in mobile login
export const loginWithTokenAction = (token) => async (dispatch) => {
  dispatch(loginStart());

  try {
    const user = await fetchUserBySessionToken({
      sessionToken: token,
    });

    setCurrentUser({
      ...user,
      id: user.id,
    });

    loginSuccess(user, dispatch);
    return user;
  } catch (e) {
    loginError(e, dispatch);
    throw e;
  }
};

// Used in mobile login
export const loginWithToken = (token) => {
  const store = getStore();
  const { user } = store.getState();
  if (!user.isLogged && !user.isLoggingIn && !user.isRegistering) {
    return store.dispatch(loginWithTokenAction(token));
  }

  return Promise.resolve(null);
};
